import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { SignInModal } from "../../layouts/header/sign-in-modal";
import { MEMBERSHIP_GATE_CONTENT } from "../../../constants";
import "./membership-gate-banner.m.css";
import { Icon } from "../icon";

const MembershipGateBanner = ({
  isVisible,
  forumType,
  onClose,
  exploreLink,
  isLoggedIn,
  userCurrentForum
}) => {
  // State for sign-in modal
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);

  // Prevent body scrolling when gate is visible
  useEffect(() => {
    if (isVisible) {
      // Save current scroll position
      const scrollY = window.scrollY;

      // Prevent scrolling
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';

      return () => {
        // Restore scrolling
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

        // Restore scroll position
        window.scrollTo(0, scrollY);
      };
    }
  }, [isVisible]);

  if (!isVisible) return null;

  const handleOverlayClick = (e) => {
    if (onClose && e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div styleName="membership-gate-overlay" onClick={handleOverlayClick}>
      {onClose && (
        <button styleName="close-button" onClick={onClose} aria-label={MEMBERSHIP_GATE_CONTENT.CLOSE_GATE_LABEL}>
          <Icon name="close" size="xsmall" />
        </button>
      )}

      <div styleName="membership-gate-content">
        {isLoggedIn ? (
          // Content for logged-in users
          <div styleName="membership-gate-inner">
            <h1 styleName="main-heading">
              {MEMBERSHIP_GATE_CONTENT.EXCLUSIVE_TO_MEMBERS_PREFIX} <span styleName="brand-highlight">IMA {forumType} forum</span>
            </h1>

            <p styleName="benefits-text">
              {MEMBERSHIP_GATE_CONTENT.LIMITED_ACCESS_MESSAGE} IMA {userCurrentForum} forum
            </p>

            <Link href={exploreLink} styleName="primary-button">
              {MEMBERSHIP_GATE_CONTENT.EXPLORE_RESEARCH_HUB}
            </Link>
          </div>
        ) : (
          // Content for non-logged-in users
          <div styleName="membership-gate-inner">
            <h1 styleName="main-heading">
              {MEMBERSHIP_GATE_CONTENT.EXCLUSIVE_TO_PREFIX} <span styleName="brand-highlight">IMA {forumType} Forum</span> {MEMBERSHIP_GATE_CONTENT.MEMBERS_SUFFIX}
            </h1>

            <p styleName="benefits-text">
              {MEMBERSHIP_GATE_CONTENT.NETWORK_DESCRIPTION}
            </p>

            <div styleName="action-buttons">
              <Link href="/peer-group-forums" styleName="primary-button">
                {MEMBERSHIP_GATE_CONTENT.EXPLORE_FORUMS}
              </Link>

              <div styleName="sign-in-section">
                <span styleName="already-member-text">{MEMBERSHIP_GATE_CONTENT.ALREADY_MEMBER}</span>
                <button
                  onClick={() => setIsSignInModalOpen(true)}
                  styleName="sign-in-link"
                  type="button"
                >
                  {MEMBERSHIP_GATE_CONTENT.SIGN_IN_HERE}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Sign-in modal */}
      <SignInModal
        isOpen={isSignInModalOpen}
        onClose={() => setIsSignInModalOpen(false)}
      />
    </div>
  );
};

export { MembershipGateBanner };